import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
	Backdrop,
	CircularProgress,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Icon,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	TextField,
	Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import axios from "axios";
import {useForm} from "react-hook-form";
import {useSnackbar} from 'notistack';

const useStyles = makeStyles( ( theme ) => ({
	redButton: {
		color: '#ffffff',
		backgroundColor: '#ff0000',
		'&:hover': {
			backgroundColor: '#aa0000'
		}
	},
	dialogGrid: {
		flexGrow: 1,
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},
}));

// a feluletnek az megjelenesi allapotai lehetsegesek:
// - kiindulo allapot: a kapott szabalybeli nev, birosag es datum mezok megjelenitese inaktivan, megerosites gombbal
export default function JudgeSynonymDeleteDialog({rule, closeDialog, closeRefreshDialog, ruleRelatedDocs, saveUrl}) {
	const classes = useStyles();

	// a muveletek sikertelen/sikeres kimenetelet szovegesen mutato resz
	const {enqueueSnackbar} = useSnackbar();
	// a szerver-muveletek idejere a feluletet inaktivra allitjuk
	const [backdrop, setBackdrop] = React.useState(false);
	// a beallitott ertekek kozul a szovegeseket ezzel a modszerrel olvassuk ki (kulon inputRef-ek helyett)
	const {register, getValues} = useForm();

	const submit = () => {
		rule={ id:rule.id, ...getValues() };
		setBackdrop(true);
		const request = {
			url: saveUrl.replace( '%id', rule.id ),
			method: 'DELETE',
		};
		axios(request)
			.then(resp => {
				setBackdrop(false);
				enqueueSnackbar( 'Csereszabály szöveg: "' + rule.synonym + '" törlése sikeres', {variant: "success"} );
				setBackdrop( false );
				closeRefreshDialog();
			})
			.catch(handleError);
	};

	const handleError = (error) => {
		setBackdrop(false);
		enqueueSnackbar('Hiba történt...', {variant: "error"});
		console.log(error);
	}

	return (
	<div>
		<form noValidate autoComplete="off" onSubmit={e => e.preventDefault()}>
			<DialogTitle>
				Csereszabály törlése
			</DialogTitle>

			<DialogContent className={classes.dialogGrid}>
				<Grid container spacing={3} justify="center" alignItems="center">
					<Grid item xs={2}>
						<TextField
							name="synonym"
							variant="outlined"
							size="small"
							label="Helyettesítendő szöveg"
							fullWidth={true}
							disabled={true}
							value={rule.synonym}
							inputRef={register}
							InputProps={{
								className: classes.input
							}}
						/>
					</Grid>
					<Grid item xs={2}>
						<TextField
							name="judge"
							variant="outlined"
							size="small"
							label="Bírónév"
							fullWidth={true}
							disabled={true}
							value={rule.judge}
							inputRef={register}
							InputProps={{
								className: classes.input
							}}
						/>
					</Grid>
					<Grid item xs={2}>
						<TextField
							name="court"
							variant="outlined"
							id="combo-box-demo"
							size="small"
							disabled={true}
							fullWidth={true}
							label="Bíróság"
							value={rule.courtName}
						/>
					</Grid>
					<Grid item xs={2}>
						<TextField
							name="created"
							variant="outlined"
							size="small"
							disabled={true}
							fullWidth={true}
							label="Létrehozás dátuma"
							value={rule.createDate}
							InputProps={{
								className: classes.input
							}}
						/>
					</Grid>
					<Grid item xs={1}>
						<TextField
							name="modified"
							variant="outlined"
							size="small"
							disabled={true}
							fullWidth={true}
							label="Módosítás dátuma"
							value={rule.modifiedDate}
							InputProps={{
								className: classes.input
							}}
						/>
					</Grid>
					<Grid item xs={1}>
						<TextField
							name="username"
							variant="outlined"
							size="small"
							disabled={true}
							fullWidth={true}
							label="Utolsó módosító"
							value={rule.username}
							InputProps={{
								className: classes.input
							}}
						/>
					</Grid>
					<Grid item xs={2}>
						<TextField
							name="comment"
							variant="outlined"
							size="small"
							disabled={true}
							fullWidth={true}
							label="Megjegyzés"
							value={rule.comment}
							InputProps={{
								className: classes.input
							}}
						/>
					</Grid>
				</Grid>
				<br/>
				{ ruleRelatedDocs &&
					<div>
						<Typography variant="body1">
							A csereszabálybeli '{rule.judge}' bírónév az alábbi dokumentum(ok) meta-adataiban szerepel, melyekből szintén törlésre kerül:
						</Typography>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell align="right" className={classes.indexCol}>#</TableCell>
									<TableCell align="right">ID</TableCell>
									<TableCell>FaCím1</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{ ruleRelatedDocs.map((doc, index) => (
									<TableRow key={doc.id}>
										<TableCell align="right" className={classes.indexCol}>{index + 1}.</TableCell>
										<TableCell align="right">{doc.id}</TableCell>
										<TableCell>{doc.title1}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</div>
				}
				{ !ruleRelatedDocs &&
					<Typography variant="body1">A csereszabálybeli '{rule.judge}' bírónév nem szerepel egy dokumentum meta-adataiban sem úgy, 
						hogy nincs külön ilyen valid bírónév.
					</Typography>
				}
			</DialogContent>
			<DialogActions>
				<Button onClick={closeDialog} color="primary" autoFocus={true}>
					Mégsem
				</Button>
				<Button
					variant="contained"
					color="primary"
					type="button"
					className={classes.redButton}
					startIcon={<Icon>saveIcon</Icon>}
					onClick={submit}
				>
					Bírónév csereszabály törlése
				</Button>
			</DialogActions>
		</form>

		<Backdrop className={classes.backdrop} open={backdrop}>
			<CircularProgress color="inherit"/>
		</Backdrop>
	</div>
	);
};